import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, IconButton, ListItemText, Tooltip } from "@mui/material";
import * as React from "react";
import { MouseEvent, ReactNode, useEffect, useState } from "react";
import { IDropdownAction } from "../../dropdown";
import { ToolButtonDropdownMenu } from "../ToolButtonDropdownMenu";

export interface IToolButtonDropdownProp {
    actions: IDropdownAction[];
    variant?: "text" | "outlined" | "contained" | "icon" | "danger";
    icon?: ReactNode;
    endIcon?: ReactNode;
    fullWidth?: boolean;
    buttonClasses?: string;
    classes?: string;
    disabled?: boolean;
    menuRight?: boolean; //TODO: IMPLEMENT RELATIVE POSITION TO RIGHT FROM THE BUTTON
    removeDefaultClasses?: boolean;
    stopPropagation?: boolean;
    title?: string | ReactNode;
    tooltip?: string;
    margin?: string | number;
    size?: "small" | "medium" | "large";
    getActions?: () => Promise<IDropdownAction[]>;
}

export interface IToolButtonDropdownState {
    open: boolean;
}

export const ToolButtonDropdown = ({ actions, variant = "icon", icon, disabled, title, tooltip, fullWidth = false, stopPropagation, margin, size = "medium", getActions }: IToolButtonDropdownProp) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [state, setState] = useState({ open: false, actions: [] });

    useEffect(() => {
        setState({ open: Boolean(anchorEl), actions });
    }, [actions]);

    const handleToggleClick = async (event: MouseEvent<HTMLElement>) => {
        const element = event.currentTarget;
        if (stopPropagation) event.stopPropagation();
        setAnchorEl(event.currentTarget);
        if (!getActions) {
            setState((old) => ({
                ...old,
                open: Boolean(element)
            }));
            return;
        }
        const result = await getActions();
        if (!result) return;
        setState({ open: Boolean(element), actions: result });
    };

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    // const handleActionClick = (event: MouseEvent<HTMLElement>, action: IDropdownAction) => {
    //     if (!action) return;
    //     if (action.disabled) return;
    //     action.onClick();
    //     handleClose();
    // };

    return (
        <div>
            <Tooltip title={tooltip}>
                <>
                    {variant !== "icon" && (
                        <Button
                            variant={variant === "danger" ? "contained" : variant}
                            disabled={disabled}
                            fullWidth={fullWidth}
                            onClick={handleToggleClick}
                            startIcon={icon}
                            color={variant === "danger" ? "error" : undefined}
                            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            sx={{ margin }}
                            size={size}
                        >
                            <ListItemText sx={{ flex: "2", textAlign: "start" }} primaryTypographyProps={{ variant: "body2", textTransform: "capitalize" }}>{title}</ListItemText>
                        </Button>
                    )}
                    {variant === "icon" && (
                        <IconButton disabled={disabled} onClick={handleToggleClick} sx={{ margin }}>
                            {icon}
                        </IconButton>
                    )}
                </>
            </Tooltip>
            <ToolButtonDropdownMenu
                anchorEl={anchorEl}
                actions={state.actions}
                onClose={() => setAnchorEl(null)}
            />
            {/* <Menu
                anchorEl={anchorEl}
                open={state.open}
                onClose={handleClose}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
                {state.actions.map((action, index) => action.onClick && (
                    action.divider
                        ? <Divider key={`divider-${index}`} />
                        : (<MenuItem key={typeof action.title === "string" ? action.title : `divider-${index}`} onClick={(event) => handleActionClick(event, action)} disabled={action.disabled}>
                            {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
                            <ListItemText>{action.title}</ListItemText>
                        </MenuItem>)
                ))}
            </Menu> */}
        </div>
    );
};
